import { useState } from "react";
import { ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import ListingsManager from "./ListingsManager";
import CategoriesManager from "./CategoriesManager";
import HeroEditor from "./HeroEditor";
import SlidesManager from "./SlidesManager";
import MarketplaceAnalytics from "./MarketplaceAnalytics";

const TABS = [["carousel", "Carousel"], ["listings", "Listings"], ["categories", "Categories"], ["hero", "Static hero (fallback)"], ["analytics", "Analytics"]];

export default function MarketplaceAdmin() {
  const [sub, setSub] = useState("carousel");
  return (
    <div className="mt-8" data-testid="marketplace-admin">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
        <div className="flex gap-2 flex-wrap">
          {TABS.map(([k, l]) => (
            <button key={k} data-testid={`mkt-admin-tab-${k}`} onClick={() => setSub(k)}
              className={`px-3 py-1.5 text-[10px] tracking-widest uppercase rounded border ${sub === k ? "bg-[#D4AF37] text-black border-[#D4AF37]" : "border-white/15 text-neutral-300 hover:text-white"}`}>{l}</button>
          ))}
        </div>
        <Link to="/" target="_blank" data-testid="mkt-admin-open-preview" className="btn-ghost-gold px-3 py-2 rounded text-xs tracking-widest uppercase inline-flex items-center gap-2">
          <ExternalLink size={13} /> View homepage
        </Link>
      </div>
      {sub === "carousel" && <SlidesManager />}
      {sub === "listings" && <ListingsManager />}
      {sub === "categories" && <CategoriesManager />}
      {sub === "hero" && <HeroEditor />}
      {sub === "analytics" && <MarketplaceAnalytics />}
    </div>
  );
}
